import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { MdOutlineSpaceDashboard } from 'react-icons/md';
import './AttendanceStatusCard.scss';
import { formatNumber } from 'utils/utils';
import { useTranslation } from 'react-i18next';

const hexToRgba = (hex, alpha) => {
  const match = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!match) return null;
  const [, r, g, b] = match;
  return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${alpha})`;
};

const AttendanceStatusCard = ({
  title,
  activeLabel,
  pauseLabel,
  absentLabel,
  summary,
  iconColor = '#9E9DAB',
}) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('attendance.statusCard.title');
  const resolvedActiveLabel = activeLabel ?? t('attendance.statusCard.activeLabel');
  const resolvedPauseLabel = pauseLabel ?? t('attendance.statusCard.pauseLabel');
  const resolvedAbsentLabel = absentLabel ?? t('attendance.statusCard.absentLabel');

  const STATUS_HELP_TEXT = (
    <div className="kpi-attendance-help-tooltip-body">
      {t('attendance.statusCard.helpActive')}
      <br />
      {t('attendance.statusCard.helpPause')}
      <br />
      {t('attendance.statusCard.helpAbsent')}
    </div>
  );

  const activeValue = summary?.total_active_employees ?? '—';
  const pauseValue = summary?.total_break_employees ?? '—';
  const absentValue = summary?.total_absent_employees ?? '—';

  const resolvedIconColor = iconColor || '#9E9DAB';
  const resolvedIconBg =
    (iconColor && hexToRgba(iconColor, 0.3)) || 'rgba(0, 0, 0, 0.06)';

  return (
    <div className="kpi-card-attendance-summary">
      <div className="kpi-attendance-header">
        <div className="kpi-attendance-title">
          <span className="kpi-attendance-title-text">{resolvedTitle}</span>
          <OverlayTrigger
            placement="top"
            delay={{ show: 200, hide: 100 }}
            overlay={(props) => (
              <Tooltip
                id="tooltip-attendance-status-card-help"
                {...props}
                className="kpi-attendance-help-tooltip"
              >
                {STATUS_HELP_TEXT}
              </Tooltip>
            )}
          >
            <span
              className="kpi-attendance-help"
              role="button"
              tabIndex={0}
              aria-label={t('attendance.statusCard.helpAriaLabel')}
            >
              ?
            </span>
          </OverlayTrigger>
        </div>
        <div
          className="kpi-attendance-layout-icon"
          style={{ color: resolvedIconColor, backgroundColor: resolvedIconBg }}
        >
          <MdOutlineSpaceDashboard />
        </div>
      </div>

      <div className="kpi-attendance-body">
        <div className="kpi-attendance-item kpi-attendance-item-active">
          <div className="kpi-attendance-value">
            {formatNumber(activeValue)}
          </div>
          <div className="kpi-attendance-label">{resolvedActiveLabel}</div>
        </div>
        <div className="kpi-attendance-divider" />
        <div className="kpi-attendance-item kpi-attendance-item-pause">
          <div className="kpi-attendance-value">
            {formatNumber(pauseValue)}
          </div>
          <div className="kpi-attendance-label">{resolvedPauseLabel}</div>
        </div>
        <div className="kpi-attendance-divider" />
        <div className="kpi-attendance-item kpi-attendance-item-absent">
          <div className="kpi-attendance-value">
            {formatNumber(absentValue)}
          </div>
          <div className="kpi-attendance-label">{resolvedAbsentLabel}</div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceStatusCard;

